module.exports = __webpack_public_path__ + "img/ico-img.c08d0ee9.png";